import type { Component } from 'vue';
import Tag from './Tag.vue';

export default new Map<string, Component>([
  ['Tag', Tag],  
]);

